import { signInWithPopup, FacebookAuthProvider } from "firebase/auth";
import { auth } from "../config/firebase";
import AuthenticationService from "../services/AuthenticationService";

const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope("email");

export const useFacebookSignIn = () => {
  const signIn = async ({ affiliate = null, newsletter = false } = {}) => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      const idToken = await result.user.getIdToken();

      const response = await AuthenticationService.firebaseLogin({
        token: idToken,
        user_service: false,
        affiliate,
        newsletter,
      });

      return response;
    } catch (error) {
      console.error("Facebook login error:", error);

      if (error?.code === "auth/account-exists-with-different-credential") {
        const email = error?.customData?.email;

        throw new Error(
          email
            ? `An account already exists for ${email} with a different sign-in method. Please sign in using your existing provider, such as Google, Apple, or email and password.`
            : "An account already exists with a different sign-in method. Please sign in using your existing provider, such as Google, Apple, or email and password.",
        );
      }

      if (error?.code === "auth/popup-closed-by-user") {
        throw new Error("Facebook sign-in was cancelled.");
      }

      if (error?.code === "auth/popup-blocked") {
        throw new Error("The sign-in popup was blocked by your browser. Please allow popups and try again.");
      }

      throw new Error("Facebook sign-in failed. Please try again.");
    }
  };

  return { signIn };
};
